import { Pipe, PipeTransform, Inject, LOCALE_ID } from '@angular/core';
import { FrameResource as ZH_CHS } from '../i18n/zh-CHS/FrameResource';
import { FrameResource as EN } from '../i18n/en/FrameResource';
import { FrameResource as ZH_CHT } from '../i18n/zh-CHT/FrameResource';
import { CheckResource as ZH_CHS_Check } from '../i18n/zh-CHS/CheckResource';
import { CheckResource as EN_Check } from '../i18n/en/CheckResource';
import { CheckResource as ZH_CHT_Check } from '../i18n/zh-CHT/CheckResource';

/**
 * 表达式资源国际化通道
 */
@Pipe({ name: 'locale' })
export class ExpressionEditorLocalePipe implements PipeTransform {

  //语言编号
  private languageCode: string;
  //框架资源
  private resource: {};
  //语法校验资源
  private checkResource: {};

  //构造资源
  constructor(@Inject(LOCALE_ID) localeId: string) {
    localeId = localStorage.getItem('languageCode') || 'zh-CHS';
    this.languageCode = localeId || "zh-CHS";

    //语言扩展时，此处需调整
    if (this.languageCode == 'en')
      this.resource = EN;
    else if (this.languageCode == "zh-CHT")
      this.resource = ZH_CHT;
    else
      this.resource = ZH_CHS;

    //语言扩展时，此处需调整
    if (this.languageCode == 'en')
      this.checkResource = EN_Check;
    else if (this.languageCode == "zh-CHT")
      this.checkResource = ZH_CHT_Check;
    else
      this.checkResource = ZH_CHS_Check;
  }

  //获取资源
  transform(name: string): any {
    return this.resource[name] || name;
  }

  //获取语法校验资源
  check(name: string): any {
    return this.checkResource[name] || name;
  }

}
